<script>
import FirebaseNodeV3 from '../../base/FirebaseNode'
import BrandLogo from "../../../editor/nodes/BrandLogo.vue";

export default BrandLogo.extend({
  name: "BrandLogoV3",
  mixins: [FirebaseNodeV3],
})
</script>
